import Resources from './resources';
import sessionIdActions from '../containers/app/session-id/session-id-actions';

/**
 * Handles intercepting responses and saving sessionId and intercepting requests and
 * appending sessionId query param
 */
export default class SessionIdHelper {
    static addInterceptors(store) {
        const reqInterceptor = this.appendSessionIdQueryParam.bind(this, store);
        const resInterceptor = this.saveSessionId.bind(this, store);
        Resources.env.addRequestInterceptor(reqInterceptor);
        Resources.env.addResponseInterceptor(resInterceptor);
    }

    static appendSessionIdQueryParam(store, verb) {
        if (verb.url.indexOf('@StudentReportsGatewayBaseUrl') === 0) {
            const { sessionId } = store.getState();
            if (sessionId) {
                verb.withParams({
                    ...verb.parameters,
                    sessionId
                });
            }
        }
    }

    static saveSessionId(store, response) {
        if (response.valid && response.data) {
            const { sessionId } = response.data;
            if (sessionId) {
                if (store.getState().sessionId !== sessionId) {
                    store.dispatch(sessionIdActions.setSessionId(sessionId));
                }
            }
        }
        return response;
    }
}



// WEBPACK FOOTER //
// ./helpers/sessionid-helper.js